import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavDropdown, Navbar, Nav, Container, Image } from "react-bootstrap";
import { MdBuild, MdOutlineSearch, MdAccountCircle } from "react-icons/md";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import logoEasyGouv from "../../assets/images/logoEasyGouv.png";
import { apiSanitizeUser } from "../../api/ApiUser";
import ComponentModaleNotifier from "./ComponentModaleNotifier";
import { BsBell, BsStopwatch } from "react-icons/bs";
import { MdAutoGraph } from "react-icons/md";
import { GiEarthAfricaEurope, GiTrail, GiTreeDoor } from "react-icons/gi";
import { BsPersonFill } from "react-icons/bs";

import ComponentSearch from "./ComponentSearch";
import ComponentFooter from "./ComponentFooter";
import ComponentModaleNotifierListe from "./ComponentModaleNotifierListe";

const ComponentMenu = (props) => {
  const { t } = useTranslation();
  const { menuActif } = props;
  const navigate = useNavigate();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail, ReduxUserIdColidee, ReduxInstancesAutorisees, ReduxUserPicture } =
    useSelector((state) => state.ReduxUser);
  const [showModalNotif, setShowModalNotif] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showListNotifications, setShowListNotifications] = useState(false);

  /* se déconnecter */
  const logout = async () => {
    /* on va regarder si le gars a un deviceToken afin de le remettre dans le local storage pour la prochaine connexion de sa part */
    const deviceTokenSauvegarde = localStorage.getItem("deviceToken");
    /* On vide le local storage completement en vue de la déconnexion*/
    localStorage.clear();

    /* on en profite pour virer de la collection User la valeur de notre token pour ne plus recevoir de notif sur cet appareil jusqu'à la prochaine reconnexion et remettre en place un deviceToken ^pour la prochaine connexion  */
    if (deviceTokenSauvegarde) {
      await apiSanitizeUser(ReduxUserIdColidee, {
        deviceToken: deviceTokenSauvegarde,
      });
      localStorage.setItem("deviceToken", deviceTokenSauvegarde);
    }

    navigate("/");
    return false;
  };

  /* test affichage menu adminColidee */
  const isAdminColidee = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminColideeAccess
    if (ReduxInstance.adminColideeAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  /* test affichage menu adminEasygouv */
  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  /* test affichage menu Statistiques */
  const isStatistiquesConsultables = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminStatAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  /* Si je suis souscripteur j'ai des options en plus => gérer les droits d'accès et les modules */
  const isSouscripteur = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;

    return false;
  };

  const genereMenuDropDown = () => {
    return (
      <>
        {isAdminEasygouv() && (
          <>
            <h1 className="m-2"> {t("menu.menuDropdownAdmin.Categorie1")} </h1>
            {isSouscripteur() && (
              <>
                <Link className="dropdown-item" to="/admin/easygouv/instance">
                  {t("menu.menuDropdownAdmin.parametresGeneraux")}
                </Link>
                <Link className="dropdown-item" to="/admin/easygouv/droits-administration">
                  {t("menu.menuDropdownAdmin.droitsAdministration")}
                </Link>
              </>
            )}
            <Link className="dropdown-item" to="/admin/easygouv/droits-consultation">
              {t("menu.menuDropdownAdmin.droitsConsultation")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/style">
              {t("menu.menuDropdownAdmin.style")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/marques">
              {t("menu.menuDropdownAdmin.marques")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/sous-menus">
              {t("menu.menuDropdownAdmin.sousMenus")}
            </Link>
          </>
        )}
        {isAdminEasygouv() && (
          <>
            <h1 className="m-2"> {t("menu.menuDropdownAdmin.Categorie2")}</h1>
            <Link className="dropdown-item" to="/admin/easygouv/alaune">
              {t("menu.menuDropdownAdmin.alaune")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/notifications">
              {t("menu.menuDropdownAdmin.notifications")}
            </Link>
          </>
        )}
        {isAdminEasygouv() && (
          <>
            <h1 className="m-2">{t("menu.menuDropdownAdmin.Categorie3")}</h1>
            <Link className="dropdown-item" to="/admin/easygouv/processes">
              {t("menu.menuDropdownAdmin.prcess")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/orgunits">
              {t("menu.menuDropdownAdmin.orgunits")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/orgunits/pinned">
              {t("menu.menuDropdownAdmin.pinned")}
            </Link>
            {isAdminColidee() && (
              <Link className="dropdown-item " to="/admin/colidee/espaces-colidee-to-categorie">
                {t("menu.menuDropdownAdmin.colideeToCategorie")}
              </Link>
            )}
          </>
        )}
        {isAdminEasygouv() && (
          <>
            <h1 className="m-2">{t("menu.menuDropdownAdmin.Categorie4")}</h1>
            <Link className="dropdown-item" to="/admin/easygouv/personnes">
              {t("menu.menuDropdownAdmin.personnes")}
            </Link>
          </>
        )}
        {isAdminEasygouv() && (
          <>
            <h1 className="m-2"> {t("menu.menuDropdownAdmin.Categorie5")}</h1>
            <Link className="dropdown-item" to="/admin/easygouv/engagements">
              {t("menu.menuDropdownAdmin.engagements")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/orgunits">
              {t("menu.menuDropdownAdmin.mainRituel")}
            </Link>
            {isAdminColidee() && (
              <Link className="dropdown-item " to="/admin/colidee/espaces-colidee-to-categorie">
                {t("menu.menuDropdownAdmin.mainColidee")}
              </Link>
            )}
          </>
        )}
        {isAdminEasygouv() && (
          <>
            <h1 className="m-2"> {t("menu.menuDropdownAdmin.Categorie6")}</h1>
            <Link className="dropdown-item" to="/admin/easygouv/emissions">
              {t("menu.menuDropdownAdmin.insererMedias")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/publications">
              {t("menu.menuDropdownAdmin.insererPublications")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/visualmanagement">
              {t("menu.menuDropdownAdmin.insererVM")}
            </Link>
          </>
        )}
        {isAdminEasygouv() && (
          <>
            <h1 className="m-2"> {t("menu.menuDropdownAdmin.Categorie7")}</h1>
            <Link className="dropdown-item" to="/admin/easygouv/usages">
              {t("menu.menuDropdownAdmin.usages")}
            </Link>
            <Link className="dropdown-item" to="/admin/easygouv/localisations">
              {t("menu.menuDropdownAdmin.localisations")}
            </Link>
          </>
        )}
        {isStatistiquesConsultables() && (
          <>
            <h1 className="m-2"> {t("menu.menuDropdownAdmin.Categorie8")}</h1>
            <Link className="dropdown-item" to="/admin/easygouv/statistiques">
              {t("menu.menuDropdownAdmin.statistiques")}
            </Link>
          </>
        )}
      </>
    );
  };

  const genereStyle = () => {
    let color = "#887F7F";
    let themeColor = "#ffffff";
    let themeSvgColorHamburger =
      'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e")';
    let themeSvgColorSwitch =
      'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e")';
    let themeSvgColorCheckbox =
      'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e")';

    if (ReduxInstance.couleur) {
      color = ReduxInstance.couleur;
    }
    if (!ReduxInstance.theme) {
      themeColor = "#000000";
      themeSvgColorHamburger =
        'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e")';
      themeSvgColorSwitch =
        'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e")';
      themeSvgColorCheckbox =
        'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e")';
    }

    let persoCss =
      `.containerMarquePinned {
    border-top: 2px ` +
      color +
      ` solid;
      }` +
      `.navbar-dark .navbar-toggler-icon{background-image:` +
      themeSvgColorHamburger +
      `}` +
      `.form-check-input:checked[type="checkbox"]{background-image:` +
      themeSvgColorCheckbox +
      `}` +
      `.form-switch .form-check-input:checked{background-image:` +
      themeSvgColorSwitch +
      `}` +
      `.persoBackColor,
      .containerToggleChrono .form-switch .form-check-input,
      .form-check-input:checked,
      .pointJaune
      {
        color:` +
      themeColor +
      `; background-color:` +
      color +
      `
      }
      .persoCustomNodeColor{
        color:` +
      themeColor +
      `; background-color:` +
      color +
      `
      }

      .form-range::-moz-range-thumb{
          background-color:` +
      color +
      `
      }

      footer  .containerFooterButtons .is-active{
        color:` +
      themeColor +
      `; 
       background-color:` +
      color +
      `
      }

      .persoColor,
      .navbar-dark .navbar-nav .nav-link:hover,
       .navbar-dark .navbar-nav .headerButtons:hover,
       .navbar-dark .headerSearchButtonsSmallScreen:hover,
      .navbar-dark .navbar-nav .is-active,
      .sousMenuButton:hover,
      .sousMenuContainer-paddle,
      .navbar-dark .navbar-entite
      {
        color:` +
      color +
      `
      }

      .isPinned
      {
      border-left: 3px ` +
      color +
      ` solid  !important
      }

      .filtreActif,.reservationCalendrier {
         background-color:` +
      color +
      `
    }
      .filtreNonActif {
         border: 1px ` +
      color +
      ` solid
    }
      .rdvComiteTimelinebouletteCalendrier {
        background-color:` +
      color +
      `
      }`;
    return <style>{persoCss}</style>;
  };

  return (
    <>
      {genereStyle()}

      <Navbar className="navbar-dark" expand="lg" fixed="top">
        <Container>
          <Link className="navbar-brand" to="/home">
            {ReduxInstance.logoMenuPic && (
              <Image
                style={{ maxWidth: "150px", maxHeight: "34px" }}
                src={
                  process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.logoMenuPic
                }
              />
            )}

            {!ReduxInstance.logoMenuPic && (
              <span className="navbar-entite ms-2"> {ReduxInstance.entite}</span>
            )}
          </Link>

          {/* PARTIE ecrans SMALL */}
          <Nav className="d-lg-none d-xl-none d-xxl-none flex-row align-items-center">
            <Link
              to="#"
              className="headerSearchButtonsSmallScreen  me-3"
              aria-label="Toggle navigation"
            >
              <MdOutlineSearch
                className="mt-1"
                role="button"
                size="1.6em"
                onClick={(e) => setShowSearch(!showSearch)}
              />
            </Link>
            <div className="headerSearchButtonsSmallScreen  me-4">
              <BsBell
                className="mt-1"
                role="button"
                size="1.4em"
                onClick={(e) => setShowListNotifications(!showListNotifications)}
              />
            </div>

            {isAdminEasygouv() && (
              <div id="admin-nav-dropdown-small" className="me-4">
                <NavDropdown title={<MdBuild name="home" size="1.1em" />} align="end">
                  {genereMenuDropDown()}
                </NavDropdown>
              </div>
            )}
            <div id="user-nav-dropdown-small">
              <NavDropdown
                title={
                  ReduxUserPicture ? (
                    <Image src={ReduxUserPicture} className="profilePictureDropdown" />
                  ) : (
                    <MdAccountCircle name="home" size="1.5em" />
                  )
                }
                align="end"
              >
                <Link to="/" onClick={(e) => logout()} className="dropdown-item">
                  {t("menu.menuDropdownLogout")}
                </Link>
              </NavDropdown>
            </div>
          </Nav>
          {/* FIN PARTIE ecrans SMALL */}

          {/* PARTIE ecrans XXL */}
          <Nav className="d-none d-lg-flex">
            <Link
              id="menu_1"
              className={menuActif === "home" ? "headerButtons is-active " : "headerButtons"}
              to="/home"
            >
              <BsStopwatch size="1.2em" /> <div> {t("menu.menuGeneral1")}</div>
            </Link>
            <Link
              id="menu_2"
              className={menuActif === "ingovernance" ? "headerButtons is-active" : "headerButtons"}
              to="/ingovernance"
            >
              <MdAutoGraph size="1.2em" />
              <div> {t("menu.menuGeneral2")}</div>
            </Link>

            <Link
              id="menu_3"
              className={menuActif === "insocial" ? "headerButtons is-active" : "headerButtons"}
              to="/insocial"
            >
              <BsPersonFill size="1.2em" />
              <div> {t("menu.menuGeneral3")}</div>
            </Link>

            <Link
              id="menu_4"
              className={menuActif === "inoperation" ? "headerButtons is-active" : "headerButtons"}
              to="/inoperation"
            >
              <GiEarthAfricaEurope size="1.2em" />
              <div> {t("menu.menuGeneral4")}</div>
            </Link>

            <Link
              id="menu_5"
              className={menuActif === "inviews" ? "headerButtons is-active" : "headerButtons"}
              to="/inviews"
            >
              <GiTrail size="1.2em" />
              <div> {t("menu.menuGeneral5")}</div>
            </Link>
            <Link
              id="menu_6"
              className={menuActif === "espaces" ? "headerButtons is-active" : "headerButtons"}
              to="/espaces"
            >
              <GiTreeDoor size="1.2em" />
              <div> {t("menu.menuGeneral6")}</div>
            </Link>

            <Link id="menu_search" to="#" className="headerButtons">
              <MdOutlineSearch
                className="mt-1"
                role="button"
                size="1.5em"
                onClick={(e) => setShowSearch(!showSearch)}
              />
            </Link>
            <div className="headerButtons">
              <BsBell
                className="mt-1"
                role="button"
                size="1.2em"
                onClick={(e) => setShowListNotifications(!showListNotifications)}
              />
            </div>

            <div id="user-nav-dropdown">
              <NavDropdown
                title={
                  ReduxUserPicture ? (
                    <Image src={ReduxUserPicture} className="profilePictureDropdown" />
                  ) : (
                    <MdAccountCircle name="home" size="1.5em" />
                  )
                }
                align="end"
              >
                <Link to="/" onClick={(e) => logout()} className="dropdown-item">
                  {t("menu.menuDropdownLogout")}
                </Link>
              </NavDropdown>
            </div>

            {isAdminEasygouv() && (
              <div id="admin-nav-dropdown">
                <NavDropdown title={<MdBuild name="home" size="1em" />} align="end">
                  {genereMenuDropDown()}
                </NavDropdown>
              </div>
            )}
          </Nav>
          {/* FIN PARTIE ecrans XXL */}
        </Container>
      </Navbar>
      <ComponentSearch showSearch={showSearch} setShowSearch={setShowSearch} />
      <ComponentFooter menuActif={menuActif} />
      <ComponentModaleNotifierListe
        setShowList={setShowListNotifications}
        showList={showListNotifications}
        instance={ReduxInstance}
        notifications=""
      />
    </>
  );
};

export default ComponentMenu;
